import { EditHandoverInspectionCommand } from './edit-handover-inspection-command';
import { EditHandoverIdentifiedRiskCommand } from './edit-handover-identified-risk-command';
import { EditHandoverCommand } from './edit-handover-command';
import { EditHandoverSummaryCommand } from './edit-handover-summary-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class MarkHandoverSummaryCompleteCommand {
  EditHandoverInspectionCommand: EditHandoverInspectionCommand;
  EditHandoverIdentifiedRiskCommands: EditHandoverIdentifiedRiskCommand[];
  EditHandoverCommand: EditHandoverCommand;
  EditHandoverSummaryCommand: EditHandoverSummaryCommand;
  HandoverId: string;
  OffsetFromUtc: number;
  SubmittedOn: string;
  OwnerId: string;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


